

function ErrorParagraph(prop: { message: string }) {
  return <p className="text-red-500">{prop.message}</p>;
}

export default ErrorParagraph;
